<template>
  <div class="c--customer-reviews customer-reviews-wrapper home-container-padding" v-if="!!data.length">
    <div class="container-fluid">
      <div class="airgsm-container mx-auto">
        <div class="customer-reviews-header">
          <h2 class="title-h2">
            {{ $t('components.customer.reviews.title') }}
          </h2>
        </div>

        <div class="customer-reviews-loader" v-if="isLoading || isCreating">
          <client-only>
            <v-lottie position="fixed" />
          </client-only>
        </div>

        <div
          class="customer-reviews"
          v-else-if="!isLoading"
          :class="{
            'customer-reviews-creating': isCreating,
          }"
        >
          <swiper
            ref="customerReviewSwiper"
            :options="swiperOption"
            :dir="$dir()"
            @slideChangeTransitionStart="onSwiperSlideChangeTransitionStart"
            @slideChange="onSlideChange"
          >
            <swiper-slide v-for="(item, index) in data" :key="`customer-reviews-item-${index}`">
              <ReviewItem
                class-prefix="customer-reviews-item"
                :item="item"
                :close-less-more="closeLessMore"
                :is-less-more-prevent="activeIndex !== index"
                @activeCollapsed="activeCollapsed"
              />
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button swiper-button-prev" slot="button-prev">
              <button>
                <span class="airalo-icon-arrow-right tw-text-7" />
              </button>
            </div>
            <div class="swiper-button swiper-button-next" slot="button-next">
              <button>
                <span class="airalo-icon-arrow-right tw-text-7" />
              </button>
            </div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ReviewItem from '~/components/customer-reviews/item.vue'

  import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'

  export default {
    name: 'CustomerReview',
    props: ['data'],
    components: {
      Swiper,
      SwiperSlide,
      ReviewItem,
    },
    data() {
      return {
        isCollapsedActiveElement: true,
        activeIndex: 0,
        swiperOption: {
          effect: 'coverflow',
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 30,
          coverflowEffect: {
            rotate: 0,
            scale: 0.40625,
            depth: 0,
            modifier: 1,
            slideShadows: false,
            stretch: 0,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        closeLessMore: true,
        reviews: [],
        visibleReview: true,
        isLoading: false,
        isCreating: false,
      }
    },

    methods: {
      activeCollapsed(collapsed) {
        this.closeLessMore = collapsed
        this.isCollapsedActiveElement = collapsed

        const otherElements = document.querySelectorAll('.swiper-slide:not(.swiper-slide-active) .review-item')

        if (!collapsed) {
          otherElements.forEach((element) => {
            const h = element.offsetHeight
            element.style.maxHeight = `${h}px`
          })
        } else {
          otherElements.forEach((element) => {
            element.style = null
          })
        }
      },
      onSwiperSlideChangeTransitionStart() {
        if (!this.isCollapsedActiveElement) {
          this.closeLessMore = true
        }
      },
      onSlideChange(e) {
        this.activeIndex = this.$refs.customerReviewSwiper.$swiper.activeIndex
      },
    },
  }
</script>

<style lang="scss" scoped>
  .swiper-wrapper {
    margin-left: -12.5%;
  }

  .swiper-container {
    min-height: 300px;

    @media screen and (max-width: 991px) {
      overflow: unset;
    }
  }

  .swiper-pagination {
    bottom: unset !important;
    position: relative;
    left: unset !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 22px;
    margin-bottom: 2px;

    ::v-deep .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background: #4a4a4a;
    }
    ::v-deep .swiper-pagination-bullet {
      background: #dddddd;
      margin: 0 7px;
      opacity: 1;
    }
  }

  .swiper-button {
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: unset;
    top: 136px;
    width: unset;

    @media screen and (max-width: 991px) {
      display: none;
    }

    &:after {
      display: none;
    }

    &.swiper-button-disabled {
      opacity: 1;
      button {
        color: #dddddd;
      }
    }

    &.swiper-button-prev {
      left: 0;

      [dir='rtl'] & {
        left: unset;
        right: 0;
        padding-right: 1px;
        transform: rotateY(180deg);
      }

      button {
        transform: rotate(-180deg);
      }
    }

    &.swiper-button-next {
      right: 0;
      padding-right: 1px;

      [dir='rtl'] & {
        right: unset;
        left: 0;
        padding-right: unset;
        transform: rotateY(180deg);
      }
    }

    button {
      border: none;
      outline: none;
      background: transparent;
      color: #4a4a4a;

      &.slick-disabled {
        color: #dddddd;
      }

      &.slick-prev {
        left: 0;

        & > span {
          display: inline-flex;
          transform: rotate(-180deg);
        }
      }
      &.slick-next {
        right: 0;
      }
    }
  }
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 50%;
    min-height: 300px;
    height: auto;
    margin-bottom: 0;

    ::v-deep .card.review-item {
      height: 100%;
    }

    @media screen and (max-width: 575px) {
      min-height: 360px;
    }

    @media screen and (max-width: 991px) {
      width: 100%;
    }

    &.swiper-slide-active {
      width: 50%;
      padding: 0;

      @media screen and (max-width: 991px) {
        width: 100%;
        padding: 0;
      }
    }

    &.swiper-slide-next {
      transform-origin: left;

      [dir='rtl'] & {
        transform-origin: right;
      }
    }
    &.swiper-slide-prev {
      transform-origin: right;

      [dir='rtl'] & {
        transform-origin: left;
      }
    }
  }

  .customer-reviews {
    min-height: 300px;

    &-wrapper {
      overflow: hidden;
    }

    &-loader {
      height: 334px;
      overflow: hidden;
      position: relative;
    }

    &-creating {
      display: none;
      height: 334px;
    }
  }
</style>
